import React from "react"
import moment from "moment"

import AttachmentListItem from "../../../common/AttachmentListItem"

const InsightAreaMediaEditList = ({
    media = [],
    mediaToAdd = [],
    onDelete,
    onRemove
}) => (
    <div className="margin-top--15 list-group items-list">
        {mediaToAdd
            .map((item, index) => (
                <AttachmentListItem
                    title={item.fields.attachment_title}
                    provider={item.fields.provider}
                    thumbnail_url={item.url}
                    labels={item.fields.labels.substr(1).slice(0, -1)}
                    time={moment().unix()}
                    mode="edit"
                    key={index}
                    onDelete={() => onRemove(item)}
                />
            ))
            .reverse()}
        {media.map(item => (
            <AttachmentListItem
                thumbnail_url={item.thumbnail_url || item.url}
                title={item.title}
                provider={item.provider}
                creator={item.creator}
                labels={item.labels}
                time={item.time}
                url={item.url}
                mode="edit"
                key={item.id}
                onDelete={() => onDelete(item)}
            />
        ))}
    </div>
)

export default InsightAreaMediaEditList
